import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter} from 'react-router-dom'
import Main from './Components/Main'

require('./stylesheets/main.scss');

ReactDOM.render(<BrowserRouter><Main /></BrowserRouter>, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js